// Module
var code = ``;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/working-day-cache-refresher/working-day-cache-refresher.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;